import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { ModalMensagemComponent } from 'src/app/shared/components/modal-mensagem/modal-mensagem.component';
import { FiltroResponsavelComBuscaComponent } from '../../filtro-responsavel-com-busca/filtro-responsavel.component';

@Component({
  selector: 'app-obra-perdida',
  standalone: true,
  imports: [FormsModule, CommonModule, ReactiveFormsModule, ModalMensagemComponent, FiltroResponsavelComBuscaComponent],
  templateUrl: './obra-perdida.component.html',
  styleUrls: ['./obra-perdida.component.scss'],
})
export class ObraPerdidaComponent implements OnInit {
  @Output() actionConfirmed = new EventEmitter<void>();
  @Input() idObra: number | null = null;
  @Input() moduloId: number | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() loading = new EventEmitter<boolean>();

  userId: string;
  taskDescription = '';
  responsavelSelecionado: number | null = null;
  concorrenteSelecionado: string = '';
  motivoSelecionado: string = '';
  responsavel: any[] = [];
  sucesso = false;
  successMessage: string | null = null;
  Arrconcorrentes: any[] = [];
  ArrMotivos: any[] = [];
  campoObrigatorioErro: boolean = false;
  carregando: boolean = false;

  private _errorHandleService = inject(ErrorHandleService);
  constructor(private _fichaDaObraService: FichaDaObraService) {
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit(): void {
    this.popularResponsavel();
    this.popularMotivos();
    this.popularConcorrentes();
  }

  clear(): void {
    this.taskDescription = '';
    this.responsavelSelecionado = null;
    this.concorrenteSelecionado = null;
    this.motivoSelecionado = null;
  }
  continuar() {
    this.sucesso = false;
    this.actionConfirmed.emit();
    this.close.emit();
  }

  popularResponsavel(): void {
    this._fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
        this.responsavel = response.data;

      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      }
    );
  }

  popularMotivos(): void {
       if (!this.idObra) {
      console.error('idObra não informado');

      return;
    }
    this._fichaDaObraService.listarMotivoPerda().subscribe(
      (response) => {
        this.ArrMotivos = response.data;
      },
      (error) => {
        console.error('Erro ao buscar motivos:', error);
      }
    );
  }

  popularConcorrentes(): void {
     if (!this.idObra) {
      console.error('idObra não informado');

      return;
    }
    this._fichaDaObraService.listarConcorrentes().subscribe(
      (response) => {
        this.Arrconcorrentes = response.data;
      },
      (error) => {
        console.error('Erro ao buscar concorrentes:', error);
      }
    );
  }

  atualizarObraPerdida(): void {
    if (this.carregando || !this.idObra) {
      if (!this.idObra) console.error('idObra não informado');
      return;
    }

    this.carregando = true;
    this.loading.emit(true);
    this.campoObrigatorioErro = false;

    if (!this.responsavelSelecionado) {
      this.campoObrigatorioErro = true;
    }

    if (!this.motivoSelecionado) {
      this.campoObrigatorioErro = true;
    }

    if (this.campoObrigatorioErro) {
      this.carregando = false;
      this.loading.emit(false);
      return;
    }

    const body = {
      marketID: 3,
      responsibleID: this.responsavelSelecionado
        ? Number(this.responsavelSelecionado)
        : 0,
      description: this.taskDescription || '',
      reasonForLossID: this.motivoSelecionado
        ? Number(this.motivoSelecionado)
        : 0,
      competitorsID: this.concorrenteSelecionado
        ? Number(this.concorrenteSelecionado)
        : 0,
    };

    this._fichaDaObraService.updateClienteMercado(this.idObra, body, this.moduloId).subscribe({
      next: (res) => {
        this.carregando = false;
        if (res.success) {
          this.loading.emit(false);
          this.sucesso = true;
          this.successMessage = 'Atualizado com sucesso!';
        } else {
          this.loading.emit(false);
          this._errorHandleService.throwConsoleError(res.message);
        }
      },
      error: (err) => {
        this.carregando = false;
        this.loading.emit(false);
        console.error('Erro ao atualizar obra perdida', err);
        this._errorHandleService.throwConsoleError(err.message);
      },
    });
  }
}
